<template>
  <div class="AlertsDrawer">
    <v-navigation-drawer
      class="rounded"
      style="top: 20%;"
      color="#102d69"
      height="30%"
      expand-on-hover
      mini-variant
      right
      fixed
      permanent
    >
      <v-expansion-panels>
        <v-expansion-panel v-if="alerts.length > 0">
          <v-expansion-panel-header color="#102d69">
            <h3 class="Warnings_title d-flex align-center white--text">
              <v-icon :color="colors.alerts">{{ icons.alerts }}</v-icon>
              <div class="ml-2">{{ titles.alerts }}</div>
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul class="Warnings_list">
              <li
                v-for="(row, index) in alerts"
                :key="index"
                class="Warnings_row"
              >
                {{ row }}
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="errorsList.length > 0">
          <v-expansion-panel-header color="#102d69">
            <h3 class="Warnings_title d-flex align-center white--text">
              <v-icon :color="colors.errors">{{ icons.errors }}</v-icon>
              <div class="ml-2">{{ titles.errors }}</div>
            </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul class="Warnings_list">
              <li
                v-for="(row, index) in errorsList"
                :key="index"
                class="Warnings_row"
              >
                {{ row }}
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="showTick">
          <v-expansion-panel-header color="#102d69">
            <h3 class="Warnings_title d-flex align-center white--text">
              <v-icon :color="colors.success">{{ icons.success }}</v-icon>
              <div class="ml-2">{{ titles.success }}</div>
            </h3>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    props: {
      alerts: {
        type: Array,
        default: () => [],
      },
      errors: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        icons: {
          alerts: 'mdi-alert-outline',
          errors: 'mdi-alert-circle-outline',
          success: 'mdi-check-bold',
        },
        colors: {
          alerts: 'yellow',
          errors: 'red',
          success: 'success',
        },
        titles: {
          alerts: this.$t('common.alerts'),
          errors: this.$t('common.errors'),
          success: this.$t('common.no-errors-alerts'),
        },
      }
    },
    computed: {
      showTick() {
        return this.alerts.length === 0 && this.errors.length === 0
      },
      errorsList() {
        return Object.keys(this.errors).map((error) => {
          return `${this.$t(`main.enums.fields.${error}`)} : ${this.$t(
            `main.enums.error.${this.errors[error][0]}`
          )}`
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.AlertDrawer {
  display: flex;
}
</style>
